import React from 'react'
import ThumbDownIcon from '@mui/icons-material/ThumbDown';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import QRCode from "react-qr-code";
import "./nps.css";

interface Props {
    bookingId: number;
    uuid: string;
}

const NpsRating = ({bookingId, uuid}:Props) => {

     const url = (id: any) => {
        return `https://redcliffelabs.com/bookingfeedback?type=cc_booking_english&booking_id=${bookingId}&uuid=${uuid}&rating=${id}`;
    };

  return (
     <div className="nps-rating-root">
                                            <div>
                                                <p>
                                                    <b
                                                        style={{
                                                            display: "flex",
                                                            justifyContent: "center",
                                                            marginBottom: "-15px"
                                                        }}
                                                    >
                                                        <h4>HOW WAS YOUR EXPERIENCE?</h4>
                                                    </b>
                                                    <br />
                                                    <h6
                                                        style={{
                                                            display: "flex",
                                                            justifyContent: "center",
                                                            fontSize: "14px",
                                                        }}
                                                    >
                                                        We value your feedback, please scan with your phone
                                                        camera
                                                    </h6>
                                                    <h6
                                                        style={{
                                                            display: "flex",
                                                            justifyContent: "center",
                                                            fontSize: "14px",
                                                        }}
                                                    >
                                                        and rate overall experience.
                                                    </h6>
                                                    <br />
                                                    <b
                                                        style={{
                                                            display: "flex",
                                                            justifyContent: "center",
                                                            fontSize: "14px",
                                                            marginTop: "-15px"
    
                                                        }}
                                                    >
    
                                                        How likely are you to recommend Redcliffe Labs to
                                                        your family & friends
    
    
                                                    </b>
                                                </p>
                                            </div>
                                            <div
                                                style={{
                                                    display: "flex",
                                                    justifyContent: "space-evenly",
                                                    alignItems: "center",
                                                }}
                                            >
                                                
    
                                                <span>
                                                    <a target="_blank" href={url(0)}>
                                                        <button
                                                            style={{
                                                                height: "40px",
                                                                width: "40px",
                                                                background: "rgb(234, 72, 77)",
                                                                color: "white",
                                                                border: "none",
                                                                margin: "15px 0",
                                                                fontWeight: "550",
                                                            }}
                                                        >
                                                            0
                                                        </button>
                                                       
                                                    </a>
                                                </span>
                                                <span>
                                                    <a target="_blank" href={url(1)}>
                                                        <button
                                                            style={{
                                                                height: "40px",
                                                                width: "40px",
                                                                background: "rgb(234, 72, 77)",
                                                                color: "white",
                                                                border: "none",
                                                                margin: "15px 0",
                                                                fontWeight: "550",
                                                            }}
                                                        >
                                                            1
                                                        </button>
                                                       
                                                    </a>
                                                </span>
    
                                                <span>
                                                    <a target="_blank" href={url(2)}>
                                                        <button
                                                            style={{
                                                                height: "40px",
                                                                width: "40px",
    
                                                                background: "rgb(236, 101, 78)",
                                                                color: "white",
                                                                border: "none",
                                                                margin: "15px 0",
                                                                fontWeight: "550",
                                                            }}
                                                        >
                                                            2
                                                        </button>
                                                       
                                                    </a>
                                                </span>
    
                                                <span>
                                                    <a target="_blank" href={url(3)}>
                                                        <button
                                                            style={{
                                                                height: "40px",
                                                                width: "40px",
    
                                                                background: "rgb(239, 135, 76)",
                                                                color: "white",
                                                                border: "none",
                                                                margin: "15px 0",
                                                                fontWeight: "550",
                                                            }}
                                                        >
                                                            3
                                                        </button>
                                                       
                                                    </a>
                                                </span>
    
                                                <span>
                                                    <a target="_blank" href={url(4)}>
                                                        <button
                                                            style={{
                                                                height: "40px",
                                                                width: "40px",
                                                                background: "rgb(243, 167, 76)",
                                                                color: "white",
                                                                border: "none",
                                                                margin: "15px 0",
                                                                fontWeight: "550",
                                                            }}
                                                        >
                                                            4
                                                        </button>
                                                       
                                                    </a>
                                                </span>
    
                                                <span>
                                                    <a target="_blank" href={url(5)}>
                                                        <button
                                                            style={{
                                                                height: "40px",
                                                                width: "40px",
                                                                background: "rgb(248, 196, 61)",
                                                                color: "white",
                                                                border: "none",
                                                                margin: "15px 0",
                                                                fontWeight: "550",
                                                            }}
                                                        >
                                                            5
                                                        </button>
                                                       
                                                    </a>
                                                </span>
    
                                                <span>
                                                    <a target="_blank" href={url(6)}>
                                                        <button
                                                            style={{
                                                                height: "40px",
                                                                width: "40px",
                                                                background: "rgb(225, 198, 59)",
                                                                color: "white",
                                                                border: "none",
                                                                margin: "15px 0",
                                                                fontWeight: "550",
                                                            }}
                                                        >
                                                            6
                                                        </button>
                                                        
                                                    </a>
                                                </span>
                                                <span>
                                                    <a target="_blank" href={url(7)}>
                                                        <button
                                                            style={{
                                                                height: "40px",
                                                                width: "40px",
                                                                background: "rgb(193, 204, 54)",
                                                                color: "white",
                                                                border: "none",
                                                                margin: "15px 0",
                                                                fontWeight: "550",
                                                            }}
                                                        >
                                                            7
                                                        </button>
                                                       
                                                    </a>
                                                </span>
    
                                                <span>
                                                    <a target="_blank" href={url(8)}>
                                                        <button
                                                            style={{
                                                                height: "40px",
                                                                width: "40px",
                                                                background: "rgb(159, 205, 53)",
                                                                color: "white",
                                                                border: "none",
                                                                margin: "15px 0",
                                                                fontWeight: "550",
                                                            }}
                                                        >
                                                            8
                                                        </button>
                                                        
                                                    </a>
                                                </span>
    
                                                <span>
                                                    <a target="_blank" href={url(9)}>
                                                        <button
                                                            style={{
                                                                height: "40px",
                                                                width: "40px",
                                                                background: "rgb(127, 205, 49)",
                                                                color: "white",
                                                                border: "none",
                                                                margin: "15px 0",
                                                                fontWeight: "550",
                                                            }}
                                                        >
                                                            9
                                                        </button>
                                                       
                                                    </a>
                                                </span>
    
                                                <span>
                                                    <a target="_blank" href={url(10)}>
                                                        <button
                                                            style={{
                                                                height: "40px",
                                                                width: "40px",
                                                                background: "rgb(90, 175, 43)",
                                                                color: "white",
                                                                border: "none",
                                                                margin: "15px 0",
                                                                fontWeight: "550",
                                                                textAlign: "center",
                                                            }}
                                                        >
                                                            10
                                                        </button>
                                                      
                                                    </a>
                                                </span>
    
                                            </div>
                                            <div>
                                                <div style={{
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    width: "96%"
    
                                                }}>
    
                                                    <span style={{ marginLeft: "40px" }}>
                                                        <ThumbDownIcon style={{ color: "rgb(234, 72, 77)", marginRight: "5px" }} />
                                                        Not Likely
    
                                                    </span>
    
                                                    <span >
                                                        <ThumbUpIcon style={{ color: "rgb(90, 175, 43)", marginRight: "5px" }} />
                                                        Very Likely</span>
                                                </div>
                                                <hr
                                                    style={{
                                                        background: "linear-gradient(to right, rgb(234, 72, 77), rgb(248, 196, 61), rgb(90, 175, 43))",
                                                        width: "90%",
                                                        height: "8px",
                                                        marginTop: "10px",
    
                                                    }}
                                                />
    
    
                                            </div>
    
    
                                            <div style={{ display: "flex", justifyContent: "center" }}>
    
                                                <h3>
                                                    <QRCode value={`https://redcliffelabs.com/bookingfeedback?type=cc_booking_english&booking_id=${bookingId}&uuid=${uuid}`} size={100} />
                                                </h3>
                                            </div>
                                            <div style={{ display: "flex", justifyContent: "center", fontSize: "15px", }}>
                                                <h6>Scan with your phone camera</h6>
                                            </div>
    
                                        </div>
  )
}

export default NpsRating
